/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation KeywordDirectoryUpsertMutation($keywordDirectoryId: ID, $displayName: String) {
  KeywordDirectoryUpsert(keywordDirectoryId: $keywordDirectoryId, displayName: $displayName) {
    id
    message
    status
  }
}
`
